import React from 'react';
import { connect } from 'react-redux';

import T from 'prop-types';
import cx from 'classnames';
import Link from 'redux-first-router-link';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import * as Modules from 'components/modules';
import * as actions from 'actions';
import * as selectors from 'selectors';
import styles from './header.css';
import MenuToggler from './MenuToggler';
import Arrows from './Arrows';
import Logo from './Logo';
/* eslint-disable react/prop-types */
const mobileStartPageMenuStyles = {
  enter: styles.enter,
  enterActive: styles.enterActiveSlow,
  exit: styles.exit,
  exitActive: styles.exitActive,
};
const regularMenuStyles = {
  enter: styles.enter,
  enterActive: styles.enterActive,
  exit: styles.exit,
  exitActive: styles.exitActive,
};


class Header extends React.Component {
  menuClickHandler = () => {
    const {
      activeSection,
      menuOpen,
      resetActiveSection,
      toggleMenu,
    } = this.props;
    if (activeSection) {
      resetActiveSection(false);
    } else toggleMenu(!menuOpen);
  };

  render() {
    const {
      menuOpen,
      page,
      logoHidden,
      logoColor,
      activeSection,
      headerHidden,
      pageReady,
      mobileStartPage,
      menuData,
    } = this.props;
    return (
      <div className={headerHidden ? styles.headerHidden : undefined}>

        <header className={cx(styles.root, menuOpen && styles.rootOpen)}>
          <div className={styles.fixedFix}>
            {!mobileStartPage && (
              <MenuToggler
                onClick={this.menuClickHandler}
                isOpen={menuOpen || activeSection}
                page={pageReady ? page : undefined}
                color={!menuOpen && page !== 'Home' ? logoColor : undefined}
              />
            )}
            <TransitionGroup>
              {menuOpen && (
                <CSSTransition
                  classNames={
                    mobileStartPage
                      ? mobileStartPageMenuStyles
                      : regularMenuStyles
                  }
                  key="menu"
                  in={menuOpen}
                  timeout={mobileStartPage ? 600 : 400}
                >
                  <Modules.Menu data={menuData} open={menuOpen} />
                </CSSTransition>
              )}
            </TransitionGroup>
            <Logo
              className={cx(
                (logoHidden && !menuOpen) ? styles.logoHidden : undefined,
                styles.logoDesktop,
                menuOpen && styles.logoBigZIndex,
              )}
              page={pageReady ? page : undefined}
              menuOpen={menuOpen}
            />
            <Arrows
              id="sensorViewport"
              page={page}
              menuOpen={menuOpen}
              color={!menuOpen && page !== 'Home' ? logoColor : undefined}
            />
          </div>

        </header>

        <Logo
          className={cx(
            (logoHidden && !menuOpen) ? styles.logoHidden : undefined,
            styles.logoMobile,
            menuOpen && styles.logoMobileMenuOpen,
          )}
          page={pageReady ? page : undefined}
          menuOpen={menuOpen}
        />

        {page !== 'Home' && (
          <div
            className={
              pageReady ? styles.pageOverlayHidden : styles.pageOverlay
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  menuData: selectors.getMenuData(state),
  menuOpen: selectors.getMenuVisibility(state),
  mobileStartPage: state.mobileStartPage,
  page: state.page,
  logoHidden: state.logoHidden,
  logoColor: selectors.getLogoColor(state),
  activeSection: state.activeSection,
  headerHidden: state.headerHidden,
  pageReady: state.pageReady,
});
const mapDispatchToProps = dispatch => ({
  toggleMenu: key => dispatch(actions.toggleMenu(key)),
  resetActiveSection: () => dispatch(actions.resetActiveSection()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/modules/Header/Header.js